module.exports = __webpack_public_path__ + "img/xzy.6744ff42.png";